import { styled } from "@linaria/react";
import { AiEyeIcon } from "components/AiEyeIcon/AiEyeIcon";

const Icon = styled(AiEyeIcon)``;

export const AiToastStyle = {
  Icon,
};
